<template>
  <article :class="$style['summary']">
    <component
      :is="summaryType(row.type)"
      v-for="(row, n) in summary"
      :key="`summary-${n}`">
      {{ row.value }}
    </component>
  </article>
</template>
<script setup>

const props = defineProps({
  summary: {
    type: [Array, Boolean, Object],
    default: null
  }
})

const summaryType = type => {
  if (type === 'heading') { return 'h2' }
  if (type === 'text') { return 'p' }
}

</script>
<style lang="scss" module>
.summary {
  color: $grey;

  h2 {
    font-size: $font-size-l;
    line-height: $line-height * 1.5;
  }

  p {
    font-size: $font-size-s;
    line-height: $line-height;
  }
}
</style>
